import React, { useContext } from 'react';

import ComponentHeader from '@totem/components/ComponentHeader';
import EmployeeUtilizationContext from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContext';
import EmployeeUtilizationFilters from '@totem/components/ticketing/employeeUtilization/employeeUtilizationFilters';
import EmployeeUtilizationTable from '@totem/components/ticketing/employeeUtilization/employeeUtilizationTable';
import { isNotNull } from '@totem/utilities/common';

const BulkUtilizationScreen = () => {
  const { rawData } = useContext(EmployeeUtilizationContext);

  if (isNotNull(rawData) && rawData.employees.length > 0) {
    return (
      <>
        <ComponentHeader title={'Utilization'} />
        <EmployeeUtilizationFilters defaultTimeFrame={'date'} />{' '}
        <EmployeeUtilizationTable />
      </>
    );
  }
  return <span />;
};

export default BulkUtilizationScreen;
